<template>
  <div id="navContainer">
    <div class="operations">
      <el-button type="primary" size="small" plain @click.stop="returnUpOneLevel">
        <i class="el-icon-return" style="margin-right:3px"></i>返回上一级
      </el-button>
    </div>
    <el-breadcrumb ref="breadDiv" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in navArr" :key="index" style="cursor: pointer">
        <span style="width:100%;display:block;text-align:center" class="ellipsis" :title="breadTitle(navArr,item)">
          {{ item.folderName }} </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navArr: [{ folderName: "我的分享" }]
    };
  },

  computed: {},
  watch: {},

  methods: {
    breadTitle(breadArr, item) {
      const titleArr = [];
      for (let i = 0; i < breadArr.length; i++) {
        titleArr.push(breadArr[i].folderName);
        if (breadArr[i].folderId === item.folderId) {
          break;
        }
      }
      return titleArr.join("/");
    },
    async returnUpOneLevel() {
      this.$emit("pf5");
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#navContainer {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  box-sizing: border-box;
  padding: var(--middle-space) var(--big-space);

  .operations {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .el-button--primary.is-plain {
      background: #fff;
      border-color: #4777E7;
      color: #4777E7;
    }

    .el-button--primary.is-plain:hover {
      background: #E1EAFF;
      border-color: #4777E7;
      color: #4777E7;
    }

    img {
      cursor: pointer;
    }
    /deep/ .el-icon-return {
      background: url("../../../../../../CommonDP/assets/return.png") no-repeat;
      width: 14px;
      height: 12px;
    }
    /deep/ .el-icon-return:before {
      content: "替";
      font-size: 12px;
      visibility: hidden;
    }
  }

  /deep/ .el-breadcrumb::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  /deep/ .el-breadcrumb {
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    width: 65%;
    align-items: center;
    margin-left: var(--big-space);
    background-color: #fff;
    box-sizing: border-box;

    .el-breadcrumb__item {
      display: flex;
      padding: 3px 0;
    }

    .el-breadcrumb__inner {
      display: block;
      max-width: 68px;

      span.ellipsis:hover {
        color: var(--theme-color);
      }
    }

    .el-icon-arrow-right {
      color: #000;
      margin: 0;
    }
  }
}
</style>
